import axios from "./http";
import store from "@/store/index";
let module = "/sysFile";

let baseURL = ""
if (process.env.NODE_ENV == 'development') {
  baseURL = 'http://127.0.0.1:8080';
} else if (process.env.NODE_ENV == 'production') {
  baseURL = 'https://tea.etoak.com/api/';
}


async function fileUpload(formData) {
  let data = {};
  if (!formData.has('filePath')) {
    formData.append('filePath', 'default');
  }
  data = await axios.post(module + '/fileUpload', formData, {
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    if (res.flag) {
      if (res.flag) {
        return res.obj
      }
    }
  })
  return data
}
async function fileUploadPic(formData) {
  let data = {};
  if (!formData.has('filePath')) {
    formData.append('filePath', 'default');
  }
  data = await axios.post(module + '/fileUploadpic', formData, {
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    if (res.code==200) {
      if (res.code==200) {
        return res.data
      }
    }
  })
  return data
}
// function importExcel(formData) {
//
//     if (!formData.has('filePath')) {
//         formData.append('filePath', 'default');
//     }
//     axios.post(module + '/fileUpload', formData, {
//         method: 'post',
//         headers: {
//             'Content-Type': 'multipart/form-data'
//         }
//     }).then(res => {
//         if (res.flag) {
//             if (res.flag) {
//                 this.$dialog.alert("上传成功")
//             }else {
//                 this.$dialog.alert(res.msg)
//             }
//         }
//     })
// }
function fileDownload(fileId){
  return baseURL+module+"/fileDownload/"+fileId+"?token="+store.state.token
}

export default {
  fileUpload,fileDownload,fileUploadPic
}
